export class ServerResponse {
  id?: number;
  errors?: {};
}
